import script from "./InvestFormTotals.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvestFormTotals.vue?vue&type=script&setup=true&lang=ts"

import "./InvestFormTotals.vue?vue&type=style&index=0&id=0646da6e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0646da6e"]])

export default __exports__